import Dialog from 'components/Common/Modals/Dialog'
import { FC, useRef } from 'react'
import {
  GridContainer,
  GridArea,
  CarouselWrapper,
  CarouselContainer,
} from './_styles'
import ImageRotateButton from 'components/Common/ImageRotate'
import CloseButton from './CloseButton'
import MoveSlideButton from './MoveSlideButton'
import ChevronLeft from 'components/Common/Icons/ChevronLeft'
import {
  CarouselProvider,
  useButtonBack,
  useButtonNext,
  ImageTransformProvider,
} from 'components/Common/ImagesCarousel'
import CurrentImage from './CurrentImage'
import { Image } from './_methods'
import Carousel from './Carousel'
import { KeyboardNavigation } from './KeyboardNavigation'

interface ImagesPopupProps {
  onClose: () => void
  images: Image[]
  initialImageIndex?: number
}

const ImagesPopup: FC<ImagesPopupProps> = ({
  onClose,
  images,
  initialImageIndex = 0,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  return (
    <Dialog.Wrapper onClose={onClose} noPadding>
      <CarouselWrapper>
        <ImageTransformProvider initialScale={1} initialRotation={0}>
          <CarouselProvider
            imageSize={64}
            initialImageIndex={initialImageIndex}
          >
            <KeyboardNavigation />
            <GridContainer>
              <GridArea $area='top-left'>
                <ImageRotateButton />
              </GridArea>
              <GridArea $area='top-center' />
              <GridArea $area='top-right'>
                <CloseButton onClick={onClose} />
              </GridArea>

              <GridArea $area='middle-left'>
                <CustomButtonBack />
              </GridArea>
              <GridArea $area='middle-center'>
                <CurrentImage images={images} />
              </GridArea>
              <GridArea $area='middle-right'>
                <CustomButtonNext />
              </GridArea>

              <GridArea $area='bottom-full'>
                <CarouselContainer ref={wrapperRef}>
                  <Carousel images={images} />
                </CarouselContainer>
              </GridArea>
            </GridContainer>
          </CarouselProvider>
        </ImageTransformProvider>
      </CarouselWrapper>
    </Dialog.Wrapper>
  )
}

export default ImagesPopup

// Кастомные кнопки для попапа
const CustomButtonBack: FC = () => {
  const { onClick, disabled } = useButtonBack()

  if (disabled) return null

  return (
    <MoveSlideButton onClick={onClick}>
      <ChevronLeft />
    </MoveSlideButton>
  )
}

const CustomButtonNext: FC = () => {
  const { onClick, disabled } = useButtonNext()

  if (disabled) return null

  return (
    <MoveSlideButton onClick={onClick}>
      <div style={{ transform: 'rotate(180deg)' }}>
        <ChevronLeft />
      </div>
    </MoveSlideButton>
  )
}
